import { Props } from '@components/BlockMapper';
import { video as schema } from 'web/schemas/contentful/_schema.mjs';
import { fakeProps } from 'web/schemas/contentfulTestData';

export const TestData: Partial<Props> = {
  video_source: true,
  youTubeUrl: 'https://www.youtube.com/watch?v=oznr-1-poSU',
  videoUpload:
    'https://videos.ctfassets.net/3g4b24b0tvoz/e7WxAjgu2bcStz0lJxwkN/e02445f3527d480b3868407a59e87f6d/San_Francisco_Townhouses.mp4',
  posterImage: '/assets/textimageplaceholder.png',
};

export default fakeProps(schema, TestData);
